import { motion } from "motion/react";
import { ReactNode } from "react";
import { cn } from "@/core/helpers/cn";

type Props = {
  children: ReactNode;
  className?: string;
};

export default function DeathScreenWrapper({ children, className }: Props) {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{
        duration: 0.3,
      }}
      exit={{ opacity: 0 }}
      className={cn(
        "fixed top-0 left-0 right-0 bottom-0 flex flex-col items-center justify-center gap-10",
        className,
      )}
    >
      {children}
    </motion.div>
  );
}
